// This file's entirely about extending native functionality.
/* eslint-disable no-extend-native */

/**
 * This is a polyfill for ie IE9+ that implements Element.closest() although
 * we only really need it for ie11
 *
 * I’ve copied https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 * with a minor amendment to keep the linter happy (I’ve used and arrow
 * function instead of an anonymous one at Element.prototype.closest = …)
 */
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = (s) => {
    let el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
